import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
  name: "ticketcountfilter"
})
export class TicketCountPipe implements PipeTransform {
  transform(
    data: any,
    isCategory: boolean
  ): any {
    if (data && data.length > 0) {
      if (isCategory) {
        return data.filter(x => x.TicketCount > 0);
      }
      else {
        return data.filter(x => x.Sub_TicketCount > 0);
      }
    }
    else {
      return [];
    }
  }
}